import Styleguide from "@store/Framework/Types/Styleguide";
import { linkStyles } from "@store/Themes/common/mixins/link";

const link: Styleguide["link"] = {
    defaultProps: {
        color: null as any,
        hoverStyle: null as any,
        hoverMode: null as any,
        css: linkStyles("text.link", "text.linkHover", false, true),
    },
};

export default link;
